import React from 'react';

const services = [
  {
    icon: '🤖',
    title: 'Agents IA & Automatisation',
    desc: "Nous concevons et déployons des workflows intelligents pilotés par des agents IA pour automatiser vos processus répétitifs et maximiser la productivité de vos équipes.",
    tags: ['Agents autonomes', 'Workflows IA', 'Automatisation', 'Intégrations'],
  },
  {
    icon: '🎬',
    title: 'Publicités UGC par IA',
    desc: "Générez des contenus publicitaires UGC percutants et authentiques grâce à l'IA. Présentez vos produits avec des vidéos et visuels générés en quelques minutes.",
    tags: ['Vidéos UGC', 'Contenu produit', 'Génération IA', 'Social Ads'],
  },
  {
    icon: '🌐',
    title: 'Développement Web IA',
    desc: "Création de sites web modernes, de landing pages performantes aux applications web complexes, intégrant des fonctionnalités IA pour une expérience utilisateur unique.",
    tags: ['Landing pages', 'Web Apps', 'IA intégrée', 'Design moderne'],
  },
];

export default function Services() {
  return (
    <section className="section" id="services">
      <div className="section-header">
        <span className="section-label">Ce que nous faisons</span>
        <h2 className="section-title">
          Des solutions IA <span className="g-text">taillées pour vous</span>
        </h2>
        <p className="section-sub">
          {"Trois expertises complémentaires pour transformer votre entreprise et vous donner une longueur d'avance sur la concurrence."}
        </p>
      </div>
      <div className="services-grid">
        {services.map((s) => (
          <div className="service-card" key={s.title}>
            <div className="service-icon">{s.icon}</div>
            <h3>{s.title}</h3>
            <p>{s.desc}</p>
            <div className="service-tags">
              {s.tags.map((t) => <span className="tag" key={t}>{t}</span>)}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
